module.exports = __webpack_public_path__ + "static/media/individual-icon.cddaa001.svg";